import script from "./BaseLatexElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseLatexElement.vue?vue&type=script&lang=ts&setup=true"

import "./BaseLatexElement.vue?vue&type=style&index=0&id=9a47b5f4&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a47b5f4"]])

export default __exports__